import { render, staticRenderFns } from "./BsListTile.vue?vue&type=template&id=23012d40&"
import script from "./BsListTile.vue?vue&type=script&lang=js&"
export * from "./BsListTile.vue?vue&type=script&lang=js&"
import style0 from "./BsListTile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports